import { FormInputText, List } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const CustomListContainer = styled(List)`
  max-height: 300px;

  li {
    overflow-x: visible;
    text-wrap: wrap;
  }
`;

export const TagsContainer = styled.div`
  padding: 2px;
  padding-left: 20px;

  .MuiChip-label {
    font-size: 13px;
  }

  svg {
    font-size: 11px;
    padding-left: 6px;
  }
`;

export const StyledFormInputText = styled(FormInputText)`
  input {
    min-width: 120px !important;
    min-height: 36px;
  }
`;
